import React from "react";
import PropTypes from "prop-types";
//Material imports
import Typography from "@mui/material/Typography";
import { adjustDisplayTime } from "../../../utils/TimeCalcUtil";
const DATE_FNS_LOCAL_MAP = ["xDays", "xHours", "xMinutes", "xSeconds"];
const SHORT_DATE_FNS_LOCAL_MAP = ["xDays", "xHrs", "xMins", "xSecs"];
const TimeLeftCell = ({
  localiseDate,
  value,
  onTimeOver,
  showOnlyDays,
  showShortTime
}) => {
  const [timeLeft, setTimeLeft] = React.useState(adjustDisplayTime(value, showOnlyDays));
  React.useEffect(() => {
    const countdown = setTimeout(() => {
      const newTime = adjustDisplayTime(value, showOnlyDays);
      if (newTime.seconds || newTime.minutes || newTime.hours || newTime.days) {
        setTimeLeft(newTime);
      } else {
        clearTimeout(countdown);
        if (typeof onTimeOver === "function") {
          onTimeOver();
        }
      }
    }, 1000);
  });
  const timerComponents = [];
  let onlySecondsLeft = true;
  const dateMap = showShortTime ? SHORT_DATE_FNS_LOCAL_MAP : DATE_FNS_LOCAL_MAP;
  Object.keys(timeLeft).forEach((interval, index) => {
    if (interval !== "seconds" && timeLeft[interval]) {
      onlySecondsLeft = false;
    }
    if (!timeLeft[interval]) {
      return;
    }
    if (!localiseDate) {
      timerComponents.push(/*#__PURE__*/React.createElement("span", {
        key: index
      }, timeLeft[interval], " ", interval, " "));
    } else {
      const label = localiseDate(dateMap[index], timeLeft[interval], {
        hideSuffix: true
      });
      timerComponents.push(/*#__PURE__*/React.createElement("span", {
        key: index
      }, label, " "));
    }
  });
  let renderComp = timerComponents;
  if (onlySecondsLeft && timeLeft.seconds < 5) {
    if (localiseDate) {
      renderComp = localiseDate("lessThanXSeconds", 5, {
        hideSuffix: true
      });
    } else {
      renderComp = "less than 5 seconds";
    }
  }
  return /*#__PURE__*/React.createElement(Typography, {
    color: "inherit",
    variant: "inherit"
  }, renderComp);
};
export default TimeLeftCell;
TimeLeftCell.propTypes = {
  localiseDate: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onTimeOver: PropTypes.func,
  showOnlyDays: PropTypes.bool,
  showShortTime: PropTypes.bool
};
TimeLeftCell.defaultProps = {
  showOnlyDays: false,
  showShortTime: false
};